module.exports = __webpack_public_path__ + "static/media/dog.69b919e0.png";